module.exports = __webpack_public_path__ + "img/header-title.b0254f80.png";